import React from 'react';
import styled from 'styled-components';
import logoSmartsg from '../images/logo-smartsg.jpg';
import logoKtsg from '../images/LogoKTSG_sw.png';

const LogoRow = styled.div`
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
`
const LogoSmartsgDiv = styled.div`
  width: 125px;
`;

const LogoKtsgDiv = styled.div`
  width: 200px;
  @media (max-width: 768px) {
    width: 160px;
  }
`;

const ImageResponsive = styled.img`
    display: block;
    max-width: 100%;
    height: auto;
`;

const HeaderDiv = styled.div`
    flex-shrink: 0;
    /*padding-left: 80px;*/ padding-bottom: 30px;
    @media (max-width: 768px) {
        padding-left: 0; padding-bottom: 20px;
    }
`

export const Header: React.FC = () => {
    return (
        <HeaderDiv>
            <LogoRow>
                <LogoSmartsgDiv>
                    <ImageResponsive src={logoSmartsg} alt="Logo Smart SG" />
                </LogoSmartsgDiv>
                <LogoKtsgDiv>
                    <a href="https://www.sg.ch" title="Portal sg.ch" target="_blank" rel="noreferrer">
                        <ImageResponsive src={logoKtsg} alt="Logo Kanton St.Gallen" />
                    </a>
                </LogoKtsgDiv>
            </LogoRow>
        </HeaderDiv>

    )
}